import ChoiceColor from "./ChoiceColor/ChoiceColor";
import styles from './ColorsPanel.module.scss'
import {useColors} from "../../../../hooks/useColors";
import { useStoreRoom } from "../../../../store";

const normalizeSearchValue = (value?: string | null) => value?.trim().toLowerCase() ?? "";

const isWorkbenchToolboxDecor = (decor: any) => {
    const searchValue = [decor.name, decor.code, decor.model, decor.modelId, decor.bitrixId]
        .map(normalizeSearchValue)
        .join(" ");

    return (
        searchValue.includes("верстак туллбокс") ||
        searchValue.includes("верстак тулбокс") ||
        (searchValue.includes("верстак") && searchValue.includes("тул")) ||
        searchValue.includes("workbench toolbox")
    );
};

export const ColorsPanel = () => {
    const {
        colorsItems,
        setPerfPanelsColor,
        setShelvesColor,
        setGuidesColor,
        setBracketsColor,
        setTireRacksColor,
        setWorkbenchToolboxColor,
    } = useColors()
    const hasTireRacks = useStoreRoom((state) => state.tireRacks.length > 0);
    const hasWorkbenchToolbox = useStoreRoom((state) => state.decors.some(isWorkbenchToolboxDecor));

    return <div className={styles.container}>
        <div className={styles.colorRoom}>
            <span className={styles.title}>Выберите Цвет</span>

        </div>
        <div className={styles.colorItems}>
            <div className={styles.names}>
                {/*<div className={styles.colorRow}>*/}
                {/*    <div className={styles.name}>Направляющие (вертикали и горизонтали)</div>*/}
                {/*    <ChoiceColor setColor={setGuidesColor} color={colorsItems.guides}/>*/}
                {/*</div>*/}
                <div className={styles.colorRow}>
                    <div className={styles.name}>Кронштейны, соединители, боковины шкафа, модули</div>

                    <ChoiceColor setColor={setBracketsColor} color={colorsItems.brackets}/>
                </div>
                {hasTireRacks && (
                    <div className={styles.colorRow}>
                        <div className={styles.name}>Окрашиваемые части стоек для колес</div>

                        <ChoiceColor setColor={setTireRacksColor} color={colorsItems.tireRacks}/>
                    </div>
                )}
                {hasWorkbenchToolbox && (
                    <div className={styles.colorRow}>
                        <div className={styles.name}>Опоры верстаков</div>

                        <ChoiceColor setColor={setWorkbenchToolboxColor} color={colorsItems.workbenchToolbox}/>
                    </div>
                )}
                {/*<div className={styles.colorRow}>*/}
                {/*    <div className={styles.name}>Полки</div>*/}
                {/*    <ChoiceColor setColor={setShelvesColor} color={colorsItems.shelves}/>*/}
                {/*</div>*/}
                {/*<div className={styles.colorRow}>*/}
                {/*    <div className={styles.name}>Перфпанели и планки</div>*/}
                {/*    <ChoiceColor setColor={setPerfPanelsColor} color={colorsItems.perfpanels}/>*/}
                {/*</div>*/}
            </div>
        </div>
    </div>
}
